import BellIcon from '@heroicons/react/outline/BellIcon.js';
import HomeIcon from '@heroicons/react/outline/HomeIcon.js';
import NewspaperIcon from '@heroicons/react/outline/NewspaperIcon.js';
import SearchIcon from '@heroicons/react/outline/SearchIcon.js';
import UserCircleIcon from '@heroicons/react/outline/UserCircleIcon.js';
import UserGroupIcon from '@heroicons/react/outline/UserGroupIcon.js';
import ViewGridIcon from '@heroicons/react/outline/ViewGridIcon.js';
import BellSolidIcon from '@heroicons/react/solid/BellIcon.js';
import HomeSolidIcon from '@heroicons/react/solid/HomeIcon.js';
import NewspaperSolidIcon from '@heroicons/react/solid/NewspaperIcon.js';
import SearchSolidIcon from '@heroicons/react/solid/SearchIcon.js';
import UserCircleSolidIcon from '@heroicons/react/solid/UserCircleIcon.js';
import UserGroupSolidIcon from '@heroicons/react/solid/UserGroupIcon.js';
import ViewGridSolidIcon from '@heroicons/react/solid/ViewGridIcon.js';
import { MainMenuAction, MainMenuIcon } from './types.js';
export const mainMenuIcons = {
    [MainMenuIcon.BellIcon]: BellIcon,
    [MainMenuIcon.HomeIcon]: HomeIcon,
    [MainMenuIcon.NewspaperIcon]: NewspaperIcon,
    [MainMenuIcon.SearchIcon]: SearchIcon,
    [MainMenuIcon.UserCircleIcon]: UserCircleIcon,
    [MainMenuIcon.UserGroupIcon]: UserGroupIcon,
    [MainMenuIcon.ViewGridIcon]: ViewGridIcon,
};
export const mainMenuActiveIcons = {
    [MainMenuIcon.BellIcon]: BellSolidIcon,
    [MainMenuIcon.HomeIcon]: HomeSolidIcon,
    [MainMenuIcon.NewspaperIcon]: NewspaperSolidIcon,
    [MainMenuIcon.SearchIcon]: SearchSolidIcon,
    [MainMenuIcon.UserCircleIcon]: UserCircleSolidIcon,
    [MainMenuIcon.UserGroupIcon]: UserGroupSolidIcon,
    [MainMenuIcon.ViewGridIcon]: ViewGridSolidIcon,
};
export const mainMenuDefaultItemsFactory = (intl) => {
    const { $t } = intl;
    return [
        {
            enabled: true,
            label: $t({ id: 'Navigation.Home', defaultMessage: 'Home' }),
            action: MainMenuAction.OPEN_SPACE,
            icon: MainMenuIcon.HomeIcon,
            spaceSlug: 'default::home',
            link: null,
        },
        {
            enabled: true,
            label: $t({ id: 'Navigation.Members', defaultMessage: '{MEMBERS_CC}' }),
            action: MainMenuAction.OPEN_SPACE,
            icon: MainMenuIcon.UserGroupIcon,
            spaceSlug: 'default::members',
            link: null,
        },
        {
            enabled: true,
            label: $t({ id: 'Navigation.Spaces', defaultMessage: '{SPACES_CC}' }),
            action: MainMenuAction.OPEN_SPACE,
            icon: MainMenuIcon.ViewGridIcon,
            spaceSlug: 'default::spaces',
            link: null,
        },
        {
            enabled: false,
            label: $t({ id: 'Navigation.Profile', defaultMessage: 'Profile' }),
            action: MainMenuAction.OPEN_PROFILE,
            icon: MainMenuIcon.UserCircleIcon,
            spaceSlug: null,
            link: null,
        },
    ];
};
//# sourceMappingURL=constants.js.map